import { LearningLogContainer } from 'modules/MyLearning'
import React from 'react'

type Props = {}

const LearningLog = (props: Props) => {
  return (
    <LearningLogContainer />
  )
}

export default LearningLog;